module.exports = __webpack_public_path__ + "img/residentBanner.f690a5c1.png";